import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { SparkleDecoration } from './ui/SparkleDecoration';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Valentina M.',
    location: 'Córdoba',
    kids: 'Mamá de 2 hijos',
    text: 'Empecé con el Tomo 1 y en una semana mis mañanas cambiaron completamente. Pasamos de los gritos a salir de casa con una sonrisa. Increíble.'
  }, {
    name: 'Romina G.',
    location: 'Buenos Aires',
    kids: 'Mamá de 3 hijos',
    text: 'Las tardes eran una pesadilla. Con el Tomo 4 armé una rutina y mis hijos la hacen solos. Por fin tengo tiempo para tomar un café tranquila.'
  }, {
    name: 'Luciana P.',
    location: 'Rosario',
    kids: 'Mamá de 1 hijo',
    text: 'Es el sistema que necesitaba desde que fui mamá. Práctico, claro, sin vueltas. Las viandas ahora se arman solas prácticamente.'
  }, {
    name: 'Daniela R.',
    location: 'Mendoza',
    kids: 'Mamá de 2 hijos',
    text: 'El Calendario Anual me salvó la vida. Nunca más me olvidé de nada del colegio. Siento que por fin tengo el control de mi casa.'
  }];
  return <section id="testimonios" className="py-24 bg-cream relative mt-10" data-id="element-374">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-375">
        <AnimatedSection className="text-center mb-16 relative" data-id="element-376">
          <div className="inline-block relative" data-id="element-377">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-charcoal" data-id="element-378">
              Lo que dicen las mamás que ya lo tienen
            </h2>
            <div className="absolute -top-6 -right-12" data-id="element-379">
              <SparkleDecoration size={36} color="#F2A59D" type="star" data-id="element-380" />
            </div>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto" data-id="element-381">
          {testimonials.map((test, index) => <AnimatedSection key={index} delay={index * 0.08} className="bg-rose/20 rounded-2xl p-4 md:p-5 card-relief border border-white cursor-pointer" data-id="element-382">
              <div className="flex gap-0.5 mb-2" data-id="element-383">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow-400 text-sm" data-id="element-384">
                    ⭐
                  </span>)}
              </div>
              <p className="text-charcoal text-sm italic mb-3 leading-relaxed" data-id="element-385">
                "{test.text}"
              </p>
              <div className="flex flex-col" data-id="element-386">
                <span className="font-bold text-coral text-sm" data-id="element-387">
                  {test.name}, {test.location}
                </span>
                <span className="text-charcoal/60 text-xs" data-id="element-388">{test.kids}</span>
              </div>
            </AnimatedSection>)}
        </div>
      </div>
    </section>;
}